import { useContext } from 'react';
import { BusinessAccountContext, BusinessAccountContextType } from '@/contexts/BusinessAccountContext';

const DEFAULT_CONTEXT: BusinessAccountContextType = {
  selectedAccountId: null,
  selectedAccount: null,
  setSelectedAccountId: () => {},
  clearSelectedAccount: () => {},
  accounts: null,
  isLoading: false,
};

export function useBusinessAccountContext(): BusinessAccountContextType {
  const context = useContext(BusinessAccountContext);
  // Return a safe default when provider is not mounted (e.g. admin routes)
  return context ?? DEFAULT_CONTEXT;
}

